(function () {
	const slideshow = () => {
		$(".section-blog-post").each(function () {
			if ($(this).hasClass("slider_started")) {
				return "";
			}
			$(this).addClass("slider_started");
			const id = $(this).attr("id");
      const columns = $(this).find(".swiper-wrapper").attr("data-columns");

			let swiperParms = {
				loop: true,
				centeredSlides: false,
				autoHeight: false,
				calculateHeight: false,
				keyboard: true,
				navigation: {
					nextEl: `#${id} .swiper-button-next`,
					prevEl: `#${id} .swiper-button-prev`,
				},
        slidesPerView: 1.2,
        spaceBetween: 10,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        breakpoints: {
          640: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: columns >= 3 ? 3: columns,
            spaceBetween: 20,
          },
          1024: {
            slidesPerView: columns,
            spaceBetween: 20,
          },
        },
			};
			new Swiper(`#${id} .swiper`, swiperParms);
		});
	};

	document.addEventListener("DOMContentLoaded", function () {
		slideshow();
		document.addEventListener("shopify:section:load", function () {
			slideshow();
		});
	});
})();

